module.exports = __webpack_public_path__ + "static/media/composer-pause-white.74f47475.svg";